// Imports diretos (e não pelos barrels), mesmo motivo do `EsusCadastroPacienteModal`.
import { ModalSize } from '../../../../../_metronic/helpers/enumsUI'
import { useModal } from '../../../../components/Modal/ModalContext'
import { EsusCadastroPacienteModal } from './EsusCadastroPacienteModal'
import { usePermissaoEsusCadastro } from './core/_esusCadastroPermissao'

export const ROTULO_ESUS_CADASTRO = 'Enviar cadastro ao e-SUS'

/**
 * Ação "Enviar cadastro ao e-SUS APS" de um paciente, no formato de item de menu
 * (`{ label, onClick, hidden }`): serve tanto ao `DropdownItem` de `EsusCadastroPacienteAction`
 * quanto ao menu "⋯" do `RowActions` da listagem de pacientes. O gate e o diálogo ficam aqui, no
 * módulo e-SUS — o conhecimento do contrato do PEC num lugar só (ver `EsusCadastroPacienteAction`).
 *
 * `hidden` vem do gate por grupo, que é **defesa em profundidade**: o 403 do backend continua
 * tratado no diálogo. Ver `core/_esusCadastroPermissao.ts`.
 */
export const useEsusCadastroPacienteItem = (pacienteId: number, pacienteNome?: string | null) => {
  const { showModal } = useModal()
  const podeEnviarCadastro = usePermissaoEsusCadastro()

  const onClick = () =>
    showModal({
      title: 'Enviar cadastro ao e-SUS APS',
      size: ModalSize.Medium,
      content: <EsusCadastroPacienteModal pacienteId={pacienteId} pacienteNome={pacienteNome} />,
    })

  return { label: ROTULO_ESUS_CADASTRO, onClick, hidden: !podeEnviarCadastro }
}
